<template>
	<div>
		<div class="filter-inline-panel cle">
	      <div class="list-opinion fr">
	        <el-button type="primary" size="mini" @click="is=true">{{$t('index.add')}}</el-button>
	      </div>
	    </div>
		<el-table :data="list" border size="mini">
			<!-- <el-table-column align="center" prop="send_type" :label="$t('virtualmaillist.send_type')" data-name="发送方式" width="220" :formatter="send_type_f_f"></el-table-column> -->
			<el-table-column align="center" prop="create_time" :label="$t('virtualmaillist.time')" data-name="时间" width="220">
				<template slot-scope="scope">
					{{getTime_us(scope.row.create_time,'mmddyyyy')}}   {{getTime_us(scope.row.create_time,'hh:ii')}}
				</template>
			</el-table-column>
			<el-table-column align="center" prop="title" :label="$t('virtualmaillist.title')" data-name="标题"></el-table-column>
			<el-table-column align="center" prop="content" :label="$t('virtualmaillist.content')" data-name="内容"></el-table-column>
			<el-table-column align="center" prop="status" :label="$t('virtualmaillist.children')">
				<template slot-scope="scope">
					<div v-if="scope.row.type=='public'">
						{{lang=='cn'?'公信':'Public'}}
					</div>
					<div v-else>
						<span v-for="(item,index) in scope.row.object">{{index!=0?',':''}}{{item}}</span>
					</div>
				</template>
			</el-table-column>
		</el-table>
		<div class="page-pagination">
			<el-pagination align="right" small background :hide-on-single-page="false" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages.page" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="pages.perpage" layout="total, prev, pager, next, sizes, jumper" :total="pages.count" :pager-count="5"></el-pagination>
		</div>
		<el-dialog :title="$t('virtual.private')" width="90%" :append-to-body="true" :close-on-click-modal="false" :visible="is" @close="is = false">
			<el-form ref="form" :model="form" label-position="top" :rules="rules">
				<el-row>
					<el-col :span="12">
						<el-form-item :label="$t('virtualmaillist.send_type')" data-name="发送方式" prop="send_type">
							<el-checkbox-group v-model="form.send_type">
								<el-checkbox :label="item.id" v-for="(item,index) in send_type" :key="index">{{lang=='cn'?item.cn:item.en}}</el-checkbox>
							</el-checkbox-group>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item :label="$t('virtualmaillist.type')" data-name="类型" prop="type">
							<el-radio-group v-model="form.type">
								<el-radio :label="item.id" v-for="(item,index) in type_list" :key="index">{{lang=='cn'?item.cn:item.en}}</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
				</el-row>
				<el-form-item :label="$t('virtualmaillist.children')" data-name="选择对象" prop="children_id" v-if="form.type=='private'">
					<el-checkbox-group v-model="form.children_id">
						<el-checkbox :label="item.child_id" v-for="(item,index) in childrenlist" :key="index">{{item.name}}</el-checkbox>
					</el-checkbox-group>
				</el-form-item>
				<div class="flex">
					<div class="li" v-if="send_type_is_f('sms')">
						<div class="p1">{{lang=='cn' ? send_type[0].cn : send_type[0].en}}</div>
						<el-form-item :label="$t('virtualmaillist.preview')" data-name="预览">
							<div class="yulan">Dear Able2Shine Parents, {{course_name}} on {{form.date}} will {{form.change}} due to {{form.content}}. We're sorry for the inconvenience. Thanks for your support!</div>
						</el-form-item>
						<el-form-item :label="$t('virtualmaillist.date')" data-name="原来的课程时间" prop="date">
							<el-date-picker v-model="form.date" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('index.select')"></el-date-picker>
						</el-form-item>
						<el-form-item :label="$t('virtualmaillist.change')" data-name="处理方案" prop="change">
							<el-input v-model="form.change" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
						<el-form-item :label="$t('virtualmaillist.content')" data-name="内容" prop="content_sms">
							<el-input v-model="form.content_sms" type="textarea" :maxlength="38" :autosize="{ minRows: 4, maxRows: 6}" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</div>
					<div class="li" v-if="send_type_is_f('zhannei')">
						<div class="p1">{{lang=='cn' ? send_type[1].cn : send_type[1].en}}</div>
						<el-form-item :label="$t('virtualmaillist.title')" data-name="标题" prop="title_znx">
							<el-input v-model="form.title_znx" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
						<el-form-item :label="$t('virtualmaillist.content')" data-name="内容" prop="content_znx">
							<el-input v-model="form.content_znx" type="textarea"  :autosize="{ minRows: 4, maxRows: 6}" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</div>
					<div class="li" v-if="send_type_is_f('email')">
						<div class="p1">{{lang=='cn' ? send_type[2].cn : send_type[2].en}}</div>
						<el-form-item :label="$t('course_index.xuanzyoujian')" prop="tmp_id" data-name="邮件">
							<el-select v-model="form.tmp_id" @change="tmp_id_f" class="w100" :placeholder="$t('index.select')">
								<el-option :label="item.title" :value="item.id" :key="index" v-for="(item,index) in tmplist"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item :label="$t('virtualmaillist.title')" data-name="标题" prop="title_mail">
							<el-input v-model="form.title_mail" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
						<el-form-item :label="$t('virtualmaillist.content')" data-name="内容" prop="content_mail" v-if="form.content_mail">
							<editor-bar v-model="form.content_mail"></editor-bar>
						</el-form-item>
					</div>
				</div>
			</el-form>
	      <div slot="footer" class="dialog-footer">
	        <el-button size="mini" @click.native="is = false">{{$t('index.cancel')}}</el-button>
	        <el-button size="mini" type="primary" @click.native="editSubmit('editForm')">{{$t('index.submit')}}</el-button>
	      </div>
		</el-dialog>
	</div>
</template>
<script>
// import EditorBar from '@/components/wangEnduit.vue'
export default {
	components: {
		// EditorBar,
	},
	computed: {
		rules(){
			return{
				type: [{
					required: true,
					message: this.$t('index.select')+ this.$t('virtualmaillist.type'),
					trigger: 'change'
				}],
				send_type: [{
					required: true,
					message: this.$t('index.select')+ this.$t('virtualmaillist.send_type'),
					trigger: 'change'
				}],
				children_id: [{
					required: true,
					message: this.$t('index.select')+ this.$t('virtualmaillist.children'),
					trigger: 'change'
				}],
				date: [{
					required: true,
					message: this.$t('index.select')+ this.$t('virtualmaillist.date'),
					trigger: 'change'
				}],
				tmp_id: [{
					required: true,
					message: this.$t('index.select')+ this.$t('course_index.xuanzyoujian'),
					trigger: 'change'
				}],
				change: [{
					required: true,
					message: this.$t('index.select')+ this.$t('virtualmaillist.change'),
					trigger: 'change'
				}],
				title_znx: [{
					required: true,
					message: this.$t('index.pleaseInput')+ this.$t('virtualmaillist.title'),
					trigger: 'blur'
				}],
				title_mail: [{
					required: true,
					message: this.$t('index.pleaseInput')+ this.$t('virtualmaillist.title'),
					trigger: 'blur'
				}],
				content_znx: [{
					required: true,
					message: this.$t('index.pleaseInput')+ this.$t('virtualmaillist.content'),
					trigger: 'blur'
				}],
				content_sms: [{
					required: true,
					message: this.$t('index.pleaseInput')+ this.$t('virtualmaillist.content'),
					trigger: 'blur'
				}],
				content_mail: [{
					required: true,
					message: this.$t('index.pleaseInput')+ this.$t('virtualmaillist.content'),
					trigger: 'blur'
				}],
			}
		},
	},
	props:{
		type: {
			type: String,
			default:''
		},
		course_id: {
			type: String,
			default:''
		},
		course_type: {
			type: String,
			default:''
		},
	},
	data() {
		return {
			is:false,
			pages: {
				page: 1,
				count: 0,
				perpage: 20,
			},
			maxlength:38,
			list:[],
			this_:this,
			childrenlist:[],
			send_type:[
				{
					id:'sms',
					cn:'短信',
					en:'Short Message',
				},
				{
					id:'zhannei',
					cn:'站内信',
					en:'Internal Message',
				},
				{
					id:'email',
					cn:'邮件',
					en:'Email',
				},
			],
			type_list:[
				{
					id:'private',
					cn:'私信',
					en:'Private',
				},
				{
					id:'public',
					cn:'公信',
					en:'Public',
				},
			],
			form:{
				send_type:[], //发送方式
				type:[], //类型
				children_id:[], //学生
				title_mail:'', //电子邮件
				content_mail:'',
				title_znx:'', //站内信
				content_znx:'',
				date:'', //短信内容
				change:'',
				content_sms:'',
				tmp_id:'',
			},
			course_name:'',
			tmplist:[],
		}
	},
	watch: {
		type(v){
			if (v=='private') {
				this.init();
			}
		},
	},
	// 初始事件
	mounted: function () {
		this.config();
	},
	// 事件
	methods: {
		// 获取老师列表
		config() {
			var this_ = this;
			var url = "emailTmpList";
			var datas={
				type:'notification',
			}
			this_.$post(url, datas).then((res) => {
				this_.tmplist=res;
			})
		},
		init(){
			var this_ = this;
			var url = "VirtualMailList";
			var datas = {
				course_id:this_.course_id,
				course_type: this_.course_type,
				page: this_.pages.page,
				num: this_.pages.perpage,
			};
			this_.$post(url, datas).then((res) => {
				this_.list = res.list;
				this_.course_name=this_.lang=='cn'?res.course_name_cn:res.course_name;
				this_.pages.count = res.sum;
				this_.virtualChildrenList();
			})
		},
		// 学生列表
		virtualChildrenList(){
			var this_ = this;
			var url = "virtualChildrenList";
			var datas = {
				course_id:this_.course_id,
				course_type: this_.course_type,
			};
			this_.$post(url, datas).then((res) => {
				this_.childrenlist = res;
			})
		},
		// },
		tmp_id_f(){
			var this_ = this;
			var tmplist=this_.tmplist;
			var tmp_id=this_.form.tmp_id;
			tmplist.forEach(function(e,i) {
				if (e.id==tmp_id) {
					this_.form.content_mail=e.content;
				}
			});

		},
		send_type_is_f(name){
			var send_type=this.form.send_type;
			if (send_type.indexOf(name)!=-1) {
				return true;
			}else{
				return false;
			}
		},
		guanbi(){
			this.$emit("guanbitanchu");
		},
		// 分页每页显示几条
		handleSizeChange(val) {
			var pages = this.pages;
			pages['perpage'] = val;
			this.pages = pages;
			this.init();
		},
		// 切换分页
		handleCurrentChange(val) {
			var pages = this.pages;
			pages['page'] = val;
			this.pages = pages;
			this.init();
		},
		editSubmit(){
			var this_ = this;
			this_.$refs.form.validate((valid) => {
				if (valid) {
					var url = "SendVirtualMail";
					var datas = {
						course_type:this_.course_type,
						course_id:this_.course_id,
						children_id:this_.form.children_id.join(','),
						send_type:this_.form.send_type.join(','),
						type:this_.form.type,
					}
					if (this_.send_type_is_f('sms')) {
						datas['date']=this_.form.date;
						datas['change']=this_.form.change;
						datas['content_sms']=this_.form.content_sms;
					}
					if (this_.send_type_is_f('zhannei')) {
						datas['title_znx']=this_.form.title_znx;
						datas['content_znx']=this_.form.content_znx;
					}
					if (this_.send_type_is_f('email')) {
						datas['title_mail']=this_.form.title_mail;
						datas['content_mail']=this_.form.content_mail;
					}
					this_.$post(url, datas).then((res) => {
						this_.$message.success(this_.$t('index.operation_success'));
						if (this_.$refs.form) {
							this_.$refs.form.resetFields();
						}
						this_.is=false;
						this_.init();
						
					})
				}
			})
		},
		send_type_f_f(w,s,d){
			var this_=this;
			var send_type=this.send_type;
			var name='';
			send_type.forEach(function(e,i) {
				if (e.id==d.indexOf(e.id)!=-1) {
					var name_name=this_.lang=='cn'?e.cn:e.en;
					name==''?(name=name_name):(name+=','+name);
				}
			});
			return name;
		},
	},
	// 过滤器
	filters: {

	}
}
</script>
<style scoped>
.page-pagination{
	padding: 20px 10px 0;
}
.yulan{
	line-height: 24px;
}
.flex{
	display: flex;
}
.flex .li{
	flex: 1;
	box-shadow: 0 0 30px 10px rgba(00, 0, 0, 0.1);
	padding: 10px;
	/* padding: 0 10px; */
}
.flex .li .p1{
	font-size: 20px;
}
.flex .li+.li{
	margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/virtualmaillist.vue